import { render } from "./StepHeader.vue?vue&type=template&id=77a52af6"
import script from "./StepHeader.vue?vue&type=script&lang=js"
export * from "./StepHeader.vue?vue&type=script&lang=js"

import "./StepHeader.vue?vue&type=style&index=0&id=77a52af6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__